"use strict";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.tabsListReducer = tabsListReducer;
var _useList = require("../useList");
var _useTabsList = require("./useTabsList.types");
function tabsListReducer(state, action) {
    if (action.type === _useTabsList.TabsListActionTypes.valueChange) {
        return _object_spread_props(_object_spread({}, state), {
            highlightedValue: action.value
        });
    }
    var newState = (0, _useList.listReducer)(state, action);
    var selectionFollowsFocus = action.context.selectionFollowsFocus;
    if (action.type === _useList.ListActionTypes.itemsChange) {
        if (newState.selectedValues.length > 0) {
            return _object_spread_props(_object_spread({}, newState), {
                highlightedValue: newState.selectedValues[0]
            });
        }
        (0, _useList.moveHighlight)(null, 'reset', action.context);
    }
    if (selectionFollowsFocus && newState.highlightedValue != null) {
        return _object_spread_props(_object_spread({}, newState), {
            selectedValues: [
                newState.highlightedValue
            ]
        });
    }
    return newState;
}
